/*
  Ruma Match - oyun motoru.
  Sadece kurallar: tahta, takas, eslesme, dusme, zincir, skor, power-up, engeller.
  Ekrana hicbir sey cizmez; her hamlenin sonucunu olay listesi olarak dondurur.

  Motor deterministiktir: ayni tohum + ayni hamle listesi her yerde ayni sonucu verir.
  Sunucu (api/oyun.js) oyuncunun gonderdigi hamleleri bu dosyayla bastan oynatip
  skoru ve level sonucunu kendisi hesaplar. Bu yuzden burada Math.random kullanilmaz.

  Parca: { id, m: meyve indeksi (gunes icin -1), o: null | 'y' roket-satir | 'd' roket-sutun | 'b' bomba | 'g' gunes }
  Hucre: { p: parca|null, buz: 0-2, kutu: 0-2, sar: 0-1 }
*/
(function (kok, fabrika) {
  if (typeof module === 'object' && module.exports) module.exports = fabrika();
  else kok.RumaMatchMotor = fabrika();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var OZEL_ADI = { y: 'roket', d: 'roket', b: 'bomba', g: 'gunes' };
  var ENGELLER = ['buz', 'kutu', 'sarmasik'];
  var OZELLER = ['roket', 'bomba', 'gunes'];

  // mulberry32: kucuk, hizli, her JS motorunda ayni sonucu veren rastgele sayi uretici
  function rastgele(st) {
    var t = (st.tohum = (st.tohum + 0x6D2B79F5) >>> 0);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  function tamsayi(st, n) { return Math.floor(rastgele(st) * n); }
  // Level'in meyve havuzundan rastgele bir meyve (ayar.meyveler icindeki indeksi)
  function rastgeleMeyve(st) { return st.havuz[tamsayi(st, st.havuz.length)]; }

  function hucre(st, r, c) {
    if (r < 0 || c < 0 || r >= st.boy || c >= st.en) return null;
    return st.tahta[r][c];
  }
  function yeniParca(st, m, o) { return { id: st.sonId++, m: m, o: o || null }; }
  // Power-up'lar renk eslesmesine katilmaz: sadece oyuncu oynatinca ya da baska bir patlama carpinca patlar.
  // (Rengi gunes + roket/bomba kombosu icin parca uzerinde durur.)
  function renk(st, r, c) {
    var h = hucre(st, r, c);
    return h && h.p && !h.p.o ? h.p.m : -1;
  }
  function takasEdilir(h) { return !!(h && h.p && !h.kutu && !h.sar); }
  // Yercekiminde yerinden oynamayan hucreler (kutu, sarmasik)
  function sabit(h) { return h.kutu > 0 || h.sar > 0; }

  // ---------- Kurulum ----------

  function yeni(ayar, levelNo, tohum) {
    var sev = ayar.leveller[levelNo - 1];
    if (!sev) throw new Error('level_yok');
    var st = {
      level: levelNo,
      en: ayar.tahta.en,
      boy: ayar.tahta.boy,
      // Level'da kullanilan meyveler; yazilmadiysa listenin ilk 4'u
      havuz: (sev.meyveler || ayar.meyveler.slice(0, 4)).map(function (ad) {
        var i = ayar.meyveler.indexOf(ad);
        if (i < 0) throw new Error('meyve_yok:' + ad);
        return i;
      }),
      skorAyar: ayar.skor,
      guc: ayar.guc,
      tohum: tohum >>> 0,
      sonId: 1,
      hamle: sev.hamle,
      hamleSayisi: 0,
      skor: 0,
      bitti: false,
      kazandi: false,
      hedef: sev.hedef,
      yildizEsik: sev.yildiz,
      meyveler: ayar.meyveler,
      sayac: { meyve: [], ozel: { roket: 0, bomba: 0, gunes: 0 } },
      baslangicEngel: {},
      tahta: []
    };
    for (var i = 0; i < ayar.meyveler.length; i++) st.sayac.meyve.push(0);

    for (var r = 0; r < st.boy; r++) {
      var satir = [];
      for (var c = 0; c < st.en; c++) {
        var ch = sev.duzen ? sev.duzen[r][c] : '.';
        satir.push({
          p: null,
          buz: ch === 'i' ? 1 : ch === 'I' ? 2 : 0,
          kutu: ch === 'k' ? 1 : ch === 'K' ? 2 : 0,
          sar: ch === 's' ? 1 : 0
        });
      }
      st.tahta.push(satir);
    }
    ilkDoldur(st);
    // 'g': level tahtaya hazir gunes koyar (gunesi kullanmayi ogreten level'lar icin)
    if (sev.duzen) {
      for (var gr = 0; gr < st.boy; gr++) for (var gc = 0; gc < st.en; gc++) {
        if (sev.duzen[gr][gc] === 'g') st.tahta[gr][gc].p = yeniParca(st, -1, 'g');
      }
    }
    ENGELLER.forEach(function (e) { st.baslangicEngel[e] = engelSay(st, e); });
    return st;
  }

  function ilkDoldur(st) {
    for (var deneme = 0; deneme < 100; deneme++) {
      for (var r = 0; r < st.boy; r++) {
        for (var c = 0; c < st.en; c++) {
          var h = st.tahta[r][c];
          if (h.kutu) { h.p = null; continue; }
          var m, t = 0;
          do { m = rastgeleMeyve(st); t++; } while (t < 30 && ucluYapar(st, r, c, m));
          h.p = yeniParca(st, m);
        }
      }
      if (!eslesmeleriBul(st).length && olasiHamle(st)) return;
    }
  }

  function ucluYapar(st, r, c, m) {
    return (renk(st, r, c - 1) === m && renk(st, r, c - 2) === m) ||
           (renk(st, r - 1, c) === m && renk(st, r - 2, c) === m);
  }

  function engelSay(st, tur) {
    var n = 0;
    for (var r = 0; r < st.boy; r++) for (var c = 0; c < st.en; c++) {
      var h = st.tahta[r][c];
      if ((tur === 'buz' && h.buz) || (tur === 'kutu' && h.kutu) || (tur === 'sarmasik' && h.sar)) n++;
    }
    return n;
  }

  // ---------- Eslesme bulma ----------

  // Yatay/dikey 3+ dizileri bulur, ortak hucresi olanlari tek kumede birlestirir (L/T sekilleri)
  function eslesmeleriBul(st) {
    var diziler = [], r, c, e, m;
    for (r = 0; r < st.boy; r++) {
      c = 0;
      while (c < st.en) {
        m = renk(st, r, c);
        e = c + 1;
        if (m >= 0) while (e < st.en && renk(st, r, e) === m) e++;
        if (m >= 0 && e - c >= 3) {
          var hy = [];
          for (var x = c; x < e; x++) hy.push([r, x]);
          diziler.push({ yon: 'y', m: m, hucreler: hy });
        }
        c = e;
      }
    }
    for (c = 0; c < st.en; c++) {
      r = 0;
      while (r < st.boy) {
        m = renk(st, r, c);
        e = r + 1;
        if (m >= 0) while (e < st.boy && renk(st, e, c) === m) e++;
        if (m >= 0 && e - r >= 3) {
          var hd = [];
          for (var y = r; y < e; y++) hd.push([y, c]);
          diziler.push({ yon: 'd', m: m, hucreler: hd });
        }
        r = e;
      }
    }
    if (!diziler.length) return [];

    // birlesim-bul ile ortak hucreli dizileri grupla
    var ata = diziler.map(function (_, i) { return i; });
    function bul(i) { while (ata[i] !== i) i = ata[i] = ata[ata[i]]; return i; }
    var sahip = {};
    diziler.forEach(function (d, i) {
      d.hucreler.forEach(function (h) {
        var k = h[0] * st.en + h[1];
        if (sahip[k] !== undefined) ata[bul(i)] = bul(sahip[k]);
        else sahip[k] = i;
      });
    });
    var gruplar = {}, sira = [];
    diziler.forEach(function (d, i) {
      var a = bul(i);
      if (!gruplar[a]) { gruplar[a] = { m: d.m, diziler: [], hucreler: [], set: {} }; sira.push(a); }
      var g = gruplar[a];
      g.diziler.push(d);
      d.hucreler.forEach(function (h) {
        var k = h[0] * st.en + h[1];
        if (!g.set[k]) { g.set[k] = 1; g.hucreler.push(h); }
      });
    });
    return sira.map(function (a) { return gruplar[a]; });
  }

  function ozelTuru(kume) {
    var enUzun = 0, uzunYon = null, yatay = false, dikey = false;
    kume.diziler.forEach(function (d) {
      if (d.hucreler.length > enUzun) { enUzun = d.hucreler.length; uzunYon = d.yon; }
      if (d.yon === 'y') yatay = true; else dikey = true;
    });
    if (enUzun >= 5) return 'g';
    if (yatay && dikey) return 'b';
    if (enUzun === 4) return uzunYon;
    return null;
  }

  function ozelYeri(st, kume, tur, tercih) {
    for (var i = 0; i < tercih.length; i++) {
      if (kume.set[tercih[i][0] * st.en + tercih[i][1]]) return tercih[i];
    }
    if (tur === 'b') {
      var yatay = {}, kesisim = null;
      kume.diziler.forEach(function (d) {
        if (d.yon === 'y') d.hucreler.forEach(function (h) { yatay[h[0] * st.en + h[1]] = 1; });
      });
      kume.diziler.forEach(function (d) {
        if (d.yon === 'd') d.hucreler.forEach(function (h) {
          if (!kesisim && yatay[h[0] * st.en + h[1]]) kesisim = h;
        });
      });
      if (kesisim) return kesisim;
    }
    var uzun = kume.diziler[0];
    kume.diziler.forEach(function (d) { if (d.hucreler.length > uzun.hucreler.length) uzun = d; });
    return uzun.hucreler[Math.floor((uzun.hucreler.length - 1) / 2)];
  }

  function kumeSkoru(st, tur) {
    var s = st.skorAyar;
    if (tur === 'g') return s.eslesme5;
    if (tur === 'b') return s.sekilLT;
    if (tur === 'y' || tur === 'd') return s.eslesme4;
    return s.eslesme3;
  }

  // ---------- Patlatma ----------

  /*
    Tek bir temizleme adimi. Kumeler + ek vurulan hucreler temizlenir, vurulan power-up'lar
    zincirleme patlar, yeni power-up'lar yerlestirilir.
    oncedenAktif: kombo ile zaten patlatilmis parcalarin id'leri (tekrar patlamasinlar)
  */
  function patlat(st, kumeler, tercih, ekVur, oncedenAktif, bonus, zincir) {
    var vurulan = {}, liste = [], kuyruk = [], aktif = {}, kumeHucre = {}, olusacak = [], aktiveOlan = [];
    var taban = 0;
    (oncedenAktif || []).forEach(function (id) { aktif[id] = 1; });

    function vur(r, c) {
      var h = hucre(st, r, c);
      if (!h) return;
      var k = r * st.en + c;
      if (vurulan[k]) return;
      vurulan[k] = 1;
      liste.push([r, c]);
      if (h.p && h.p.o && !aktif[h.p.id]) {
        aktif[h.p.id] = 1;
        kuyruk.push([r, c, h.p]);
      }
    }

    kumeler.forEach(function (k) {
      var tur = ozelTuru(k);
      if (tur) {
        var yer = ozelYeri(st, k, tur, tercih);
        olusacak.push({ r: yer[0], c: yer[1], m: tur === 'g' ? -1 : k.m, o: tur });
      }
      taban += kumeSkoru(st, tur);
      k.hucreler.forEach(function (h) { kumeHucre[h[0] * st.en + h[1]] = 1; vur(h[0], h[1]); });
    });
    (ekVur || []).forEach(function (h) { vur(h[0], h[1]); });

    while (kuyruk.length) {
      var q = kuyruk.shift();
      etkiUygula(st, q[0], q[1], q[2], vur);
      st.sayac.ozel[OZEL_ADI[q[2].o]]++;
      aktiveOlan.push({ r: q[0], c: q[1], o: q[2].o });
    }

    // Normal eslesmenin hemen yanindaki kutular da hasar alir
    var yanKutu = [];
    Object.keys(kumeHucre).forEach(function (k) {
      var r = Math.floor(k / st.en), c = k % st.en;
      [[1, 0], [-1, 0], [0, 1], [0, -1]].forEach(function (d) {
        var h = hucre(st, r + d[0], c + d[1]);
        var kk = (r + d[0]) * st.en + c + d[1];
        if (h && h.kutu && !vurulan[kk] && yanKutu.indexOf(kk) < 0) yanKutu.push(kk);
      });
    });

    var silinen = [], ekParca = 0;
    liste.forEach(function (rc) {
      var h = st.tahta[rc[0]][rc[1]];
      if (h.kutu) { h.kutu--; return; }
      if (!h.p) return;
      if (!kumeHucre[rc[0] * st.en + rc[1]]) ekParca++;
      silinen.push(h.p.id);
      if (h.p.m >= 0) st.sayac.meyve[h.p.m]++;
      h.p = null;
      h.sar = 0;
      if (h.buz) h.buz--;
    });
    yanKutu.forEach(function (k) { st.tahta[Math.floor(k / st.en)][k % st.en].kutu--; });

    var olusan = [];
    olusacak.forEach(function (o) {
      var p = yeniParca(st, o.m, o.o);
      st.tahta[o.r][o.c].p = p;
      olusan.push(p.id);
    });

    var carpan = Math.min(zincir, st.skorAyar.carpanMax);
    var puan = (taban + ekParca * st.skorAyar.ozelParca + (bonus || 0)) * carpan;
    st.skor += puan;

    return {
      tur: 'patla', silinen: silinen, vurulan: liste, aktive: aktiveOlan, olusan: olusan,
      puan: puan, carpan: carpan, tahta: goruntu(st),
      skor: st.skor, hedefler: hedefDurumu(st)
    };
  }

  function enCokRenk(st) {
    var say = [];
    for (var i = 0; i < st.sayac.meyve.length; i++) say.push(0);
    herParca(st, function (p) { if (p.m >= 0) say[p.m]++; });
    var en = 0;
    for (var j = 1; j < say.length; j++) if (say[j] > say[en]) en = j;
    return en;
  }

  function herParca(st, fn) {
    for (var r = 0; r < st.boy; r++) for (var c = 0; c < st.en; c++) {
      var h = st.tahta[r][c];
      if (h.p) fn(h.p, r, c, h);
    }
  }

  function etkiUygula(st, r, c, p, vur) {
    var i, j;
    if (p.o === 'y') { for (i = 0; i < st.en; i++) vur(r, i); }
    else if (p.o === 'd') { for (i = 0; i < st.boy; i++) vur(i, c); }
    else if (p.o === 'b') {
      var R = st.guc.bombaYaricap;
      for (i = -R; i <= R; i++) for (j = -R; j <= R; j++) {
        if (Math.abs(i) + Math.abs(j) <= R) vur(r + i, c + j);
      }
    } else if (p.o === 'g') {
      // Baska bir patlama gunese carpti: tahtada en cok olan meyve gider
      var m = enCokRenk(st);
      vur(r, c);
      herParca(st, function (q, rr, cc) { if (q.m === m) vur(rr, cc); });
    }
  }

  // Oyuncunun oynattigi tek power-up (dokunma ya da bir meyveyle yer degistirme): bulundugu yerde patlar
  function tekPatlat(st, r, c) {
    return patlat(st, [], [], [[r, c]], [], 0, 1);
  }

  // Iki power-up (ya da gunes + herhangi bir meyve) yer degistirince
  function komboPatlat(st, a, b, pa, pb) {
    var vurListe = [[a[0], a[1]], [b[0], b[1]]];
    var aktif = [pa.id, pb.id];
    var bonus = st.skorAyar.kombo;
    var r = b[0], c = b[1], i, j;

    function ekle(rr, cc) { if (hucre(st, rr, cc)) vurListe.push([rr, cc]); }
    function say(p) { st.sayac.ozel[OZEL_ADI[p.o]]++; }

    if (pa.o === 'g' && pb.o === 'g') {
      say(pa); say(pb);
      for (i = 0; i < st.boy; i++) for (j = 0; j < st.en; j++) ekle(i, j);
    } else if (pa.o === 'g' || pb.o === 'g') {
      var g = pa.o === 'g' ? pa : pb, diger = pa.o === 'g' ? pb : pa;
      say(g);
      if (!diger.o) {
        bonus = 0;
        herParca(st, function (q, rr, cc) { if (q.m === diger.m) ekle(rr, cc); });
      } else {
        // Gunes + roket/bomba: o renkteki butun meyveler ayni power-up'a donusup patlar
        var roket = diger.o === 'y' || diger.o === 'd';
        say(diger);
        herParca(st, function (q, rr, cc) {
          if (q.m === diger.m && q !== diger) {
            if (!q.o) q.o = roket ? ((rr + cc) % 2 ? 'y' : 'd') : 'b';
            ekle(rr, cc);
          }
        });
      }
    } else {
      var roketA = pa.o === 'y' || pa.o === 'd', roketB = pb.o === 'y' || pb.o === 'd';
      say(pa); say(pb);
      if (roketA && roketB) {
        for (i = 0; i < st.en; i++) ekle(r, i);
        for (i = 0; i < st.boy; i++) ekle(i, c);
      } else if (roketA || roketB) {
        var g2 = st.guc.roketBombaGenislik;
        for (var d = -g2; d <= g2; d++) {
          for (i = 0; i < st.en; i++) ekle(r + d, i);
          for (i = 0; i < st.boy; i++) ekle(i, c + d);
        }
      } else {
        var R = st.guc.bombaBombaYaricap;
        for (i = -R; i <= R; i++) for (j = -R; j <= R; j++) ekle(r + i, c + j);
      }
    }
    return patlat(st, [], [], vurListe, aktif, bonus, 1);
  }

  // ---------- Dusme ----------

  // Her sutunda parcalar asagi kayar, kutu ve sarmasikli hucrelerin ustunden atlar.
  // Bos kalan yerlere yukaridan yeni meyve gelir.
  function dus(st) {
    var dogan = {};
    for (var c = 0; c < st.en; c++) {
      var yerler = [], parcalar = [], r;
      for (r = st.boy - 1; r >= 0; r--) {
        var h = st.tahta[r][c];
        if (sabit(h)) continue;
        yerler.push(r);
        if (h.p) parcalar.push(h.p);
      }
      for (var i = 0; i < yerler.length; i++) st.tahta[yerler[i]][c].p = parcalar[i] || null;
      for (var j = 0; parcalar.length + j < yerler.length; j++) {
        var p = yeniParca(st, rastgeleMeyve(st));
        st.tahta[yerler[parcalar.length + j]][c].p = p;
        dogan[p.id] = -1 - j;
      }
    }
    return { tur: 'dus', dogan: dogan, tahta: goruntu(st) };
  }

  // ---------- Hamle kontrolu ----------

  function yerelUclu(st, r, c) {
    var m = renk(st, r, c);
    if (m < 0) return false;
    var s = 1, i;
    for (i = c - 1; renk(st, r, i) === m; i--) s++;
    for (i = c + 1; renk(st, r, i) === m; i++) s++;
    if (s >= 3) return true;
    s = 1;
    for (i = r - 1; renk(st, i, c) === m; i--) s++;
    for (i = r + 1; renk(st, i, c) === m; i++) s++;
    return s >= 3;
  }

  // Oynanabilir ilk hamleyi dondurur (ipucu ve "hamle kalmadi" kontrolu icin)
  function olasiHamle(st) {
    var liste = olasiHamleler(st, true);
    return liste.length ? liste[0] : null;
  }

  function olasiHamleler(st, ilki) {
    var sonuc = [];
    for (var r = 0; r < st.boy; r++) for (var c = 0; c < st.en; c++) {
      var komsu = [[r, c + 1], [r + 1, c]];
      for (var k = 0; k < 2; k++) {
        var a = st.tahta[r][c], b = hucre(st, komsu[k][0], komsu[k][1]);
        if (!takasEdilir(a) || !takasEdilir(b)) continue;
        var gecerli = !!(a.p.o || b.p.o);
        if (!gecerli) {
          var t = a.p; a.p = b.p; b.p = t;
          gecerli = yerelUclu(st, r, c) || yerelUclu(st, komsu[k][0], komsu[k][1]);
          t = a.p; a.p = b.p; b.p = t;
        }
        if (gecerli) {
          sonuc.push([[r, c], komsu[k]]);
          if (ilki) return sonuc;
        }
      }
    }
    return sonuc;
  }

  function karistir(st) {
    var yerler = [], parcalar = [];
    herParca(st, function (p, r, c, h) {
      if (!sabit(h)) { yerler.push([r, c]); parcalar.push(p); }
    });
    for (var deneme = 0; deneme < 200; deneme++) {
      for (var i = parcalar.length - 1; i > 0; i--) {
        var j = tamsayi(st, i + 1), t = parcalar[i];
        parcalar[i] = parcalar[j]; parcalar[j] = t;
      }
      yerler.forEach(function (y, n) { st.tahta[y[0]][y[1]].p = parcalar[n]; });
      if (!eslesmeleriBul(st).length && olasiHamle(st)) break;
      if (deneme > 100) {
        // Cok sikisik tahta: normal meyvelerin rengini yeniden dagit
        parcalar.forEach(function (p) { if (!p.o) p.m = rastgeleMeyve(st); });
      }
    }
    return { tur: 'karistir', tahta: goruntu(st) };
  }

  // ---------- Hedefler ----------

  function hedefDurumu(st) {
    return Object.keys(st.hedef).map(function (anahtar) {
      var hedef = st.hedef[anahtar], yapilan, toplam;
      var mi = st.meyveler.indexOf(anahtar);
      if (mi >= 0) { toplam = hedef; yapilan = st.sayac.meyve[mi]; }
      else if (OZELLER.indexOf(anahtar) >= 0) { toplam = hedef; yapilan = st.sayac.ozel[anahtar]; }
      else if (ENGELLER.indexOf(anahtar) >= 0) {
        toplam = st.baslangicEngel[anahtar];
        yapilan = toplam - engelSay(st, anahtar);
      } else if (anahtar === 'skor') { toplam = hedef; yapilan = st.skor; }
      yapilan = Math.min(yapilan, toplam);
      return { anahtar: anahtar, toplam: toplam, yapilan: yapilan, kalan: toplam - yapilan, tamam: yapilan >= toplam };
    });
  }

  // Yildiz kalan hamleye gore: level'i gecmek 1 yildiz; esik[0] kadar hamle artarsa 2, esik[1] kadar artarsa 3.
  function yildizHesap(kalan, esik) {
    return 1 + (kalan >= esik[0] ? 1 : 0) + (kalan >= esik[1] ? 1 : 0);
  }
  function yildiz(st) {
    return st.kazandi ? yildizHesap(st.hamle, st.yildizEsik) : 0;
  }

  // ---------- Hamle ----------

  /*
    a: surukelenen parcanin hucresi [r, c], b: gittigi komsu hucre.
    a ile b ayni hucreyse: o hucredeki power-up'a dokunulmustur, yerinde patlar.
    Donus: { ok, olaylar }. ok=false ise hamle harcanmaz, tahta degismez.
  */
  function hamle(st, a, b) {
    if (st.bitti) return { ok: false, neden: 'bitti', olaylar: [] };
    var dokunma = a && b && a[0] === b[0] && a[1] === b[1];
    if (!a || !b || (!dokunma && Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) !== 1)) return { ok: false, neden: 'komsu_degil', olaylar: [] };
    var ha = hucre(st, a[0], a[1]), hb = hucre(st, b[0], b[1]);
    if (!takasEdilir(ha) || !takasEdilir(hb)) return { ok: false, neden: 'oynamaz', olaylar: [] };
    if (dokunma && !ha.p.o) return { ok: false, neden: 'eslesme_yok', olaylar: [] };

    var pa = ha.p, pb = hb.p, olaylar = [], zincir = 1;
    if (dokunma) {
      st.hamle--;
      st.hamleSayisi++;
      olaylar.push(tekPatlat(st, a[0], a[1]));
    } else {
      ha.p = pb; hb.p = pa;
      var kombo = (pa.o && pb.o) || pa.o === 'g' || pb.o === 'g';
      var tekOzel = !kombo && (pa.o || pb.o);
      var kumeler = kombo || tekOzel ? null : eslesmeleriBul(st);
      if (!kombo && !tekOzel && !kumeler.length) {
        ha.p = pa; hb.p = pb;
        return { ok: false, neden: 'eslesme_yok', olaylar: [{ tur: 'geri', a: a, b: b }] };
      }
      st.hamle--;
      st.hamleSayisi++;
      olaylar.push({ tur: 'takas', a: a, b: b, tahta: goruntu(st) });
      // Roket/bomba bir meyveyle yer degistirince gittigi yerde patlar
      if (kombo) olaylar.push(komboPatlat(st, a, b, pa, pb));
      else if (tekOzel) olaylar.push(pa.o ? tekPatlat(st, b[0], b[1]) : tekPatlat(st, a[0], a[1]));
      else olaylar.push(patlat(st, kumeler, [b, a], [], [], 0, zincir));
    }
    olaylar.push(dus(st));

    for (var tur = 0; tur < 60; tur++) {
      kumeler = eslesmeleriBul(st);
      if (!kumeler.length) break;
      zincir++;
      olaylar.push(patlat(st, kumeler, [], [], [], 0, zincir));
      olaylar.push(dus(st));
    }

    var hedefler = hedefDurumu(st);
    if (hedefler.every(function (h) { return h.tamam; })) {
      var bonus = st.hamle * st.skorAyar.kalanHamle;
      st.skor += bonus;
      st.bitti = true;
      st.kazandi = true;
      olaylar.push({ tur: 'bitis', kazandi: true, bonus: bonus, kalanHamle: st.hamle, skor: st.skor });
    } else if (st.hamle <= 0) {
      st.bitti = true;
      olaylar.push({ tur: 'bitis', kazandi: false, skor: st.skor });
    } else if (!olasiHamle(st)) {
      olaylar.push(karistir(st));
    }
    return { ok: true, olaylar: olaylar };
  }

  function goruntu(st) {
    var liste = [];
    for (var r = 0; r < st.boy; r++) for (var c = 0; c < st.en; c++) {
      var h = st.tahta[r][c];
      liste.push({
        r: r, c: c, buz: h.buz, kutu: h.kutu, sar: h.sar,
        p: h.p ? { id: h.p.id, m: h.p.m, o: h.p.o } : null
      });
    }
    return liste;
  }

  /*
    Sunucu dogrulamasi: tohum + hamle listesi ile level'i bastan oynatir.
    Gecersiz bir hamle, ya da oyun bittikten sonra gelen hamle varsa gecerli=false.
  */
  function oynat(ayar, levelNo, tohum, hamleler) {
    var st = yeni(ayar, levelNo, tohum);
    if (!Array.isArray(hamleler) || hamleler.length > st.hamle) return { gecerli: false, neden: 'hamle_sayisi' };
    for (var i = 0; i < hamleler.length; i++) {
      var h = hamleler[i];
      if (st.bitti) return { gecerli: false, neden: 'fazla_hamle' };
      if (!Array.isArray(h) || h.length !== 4 || !h.every(function (x) { return Number.isInteger(x); })) {
        return { gecerli: false, neden: 'bicim' };
      }
      var s = hamle(st, [h[0], h[1]], [h[2], h[3]]);
      if (!s.ok) return { gecerli: false, neden: 'gecersiz_hamle', sira: i };
    }
    return {
      gecerli: true, bitti: st.bitti, kazandi: st.kazandi, skor: st.skor,
      yildiz: yildiz(st), hamleSayisi: st.hamleSayisi
    };
  }

  return {
    yeni: yeni,
    hamle: hamle,
    oynat: oynat,
    goruntu: goruntu,
    hedefDurumu: hedefDurumu,
    yildiz: yildiz,
    yildizHesap: yildizHesap,
    olasiHamle: olasiHamle,
    olasiHamleler: olasiHamleler,
    OZEL_ADI: OZEL_ADI
  };
});
